module.exports = __webpack_public_path__ + "static/media/convertible-avatar.fffa45e7.svg";